import React, { useEffect } from 'react';
import { number } from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { ListTileDesktop, ListTilePlaceholder } from '@thd-olt-component-react/list-tile';
import {
  Carousel, Row, Col, Card, CardContent, CardTitle, Button
} from '@thd-olt-component-react/core-ui';
import { EmptyMessagingPhp } from './empty-messaging/EmptyMessagingPhp';
import { dataModel } from './dataModel';
import { useLists } from './useLists';
import styles from './user-lists.module.scss';
import { CreateButtonDesktop } from './create-button/create-button-desktop';

export const UserListsCarousel = ({ page }) => {
  const { lists, loading, error, refetchLists } = useLists({ page });

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('user-lists-carousel.ready');
  }, []);

  let sortedList = [...lists];
  sortedList = sortedList.sort((lista, listb) => listb?.itemCount - lista?.itemCount);

  const handleListCreation = (options) => {
    refetchLists({ page: 1 });
  };

  const onDelete = () => {
    refetchLists({ page });
  };

  const handleOnClick = (listUrl) => {
    window.location.href = window.origin + listUrl;
  };
  const slides = {
    slidesPerView: 1,
    slidesPerGroup: 1,
  };
  return (
    <div className={styles['user-lists']}>
      <Row>
        {!sortedList?.length && loading && Array.from(Array(2)).map((i, index) => {
          return (
            <Col fallback={3} key={`placeholder-${index}`}>
              <ListTilePlaceholder data-testid="lists-placeholder" />
            </Col>
          );
        })}
      </Row>
      {sortedList?.length > 0 && !loading && (
        <div>
          <CardTitle
            title="My Lists"
            action={{
              href: '/list/view/summary',
              content: (
                <Button link transparent>
                  View All Lists
                </Button>
              ),
            }}
          />
          <div className={styles['user-lists__carousel']}>
            <CardContent overflowHidden>
              <Row>
                {sortedList?.length > 1 && (
                  <Carousel
                    slidesPerView={1}
                    breakpoints={{
                      sm: slides,
                      md: slides,
                      lg: slides,
                      xl: slides,
                    }}
                  >
                    {sortedList?.map((list, listIndex) => {
                      return (
                        <ListTileDesktop
                          onClick={() => { handleOnClick(list.url); }}
                          listId={list.id}
                          onDelete={onDelete}
                          data={list}
                          width="100%"
                          height="auto"
                          key={listIndex}
                        />
                      );
                    })}
                  </Carousel>
                )}
                {sortedList?.length === 1
          && sortedList?.map((list, listIndex) => {
            return (
              <ListTileDesktop
                onClick={() => {
                  handleOnClick(list.url);
                }}
                listId={list.id}
                onDelete={onDelete}
                data={list}
                width="100%"
                key={listIndex}
              />
            );
          })}
              </Row>
            </CardContent>
          </div>
        </div>
      )}
      {!sortedList?.length && !loading && (
        <div>
          <CardTitle
            title="My Lists"
          />
          <div className={styles['user-lists__carousel']}>
            <EmptyMessagingPhp>
              <CreateButtonDesktop onCreate={handleListCreation} tag="a" link transparent />
            </EmptyMessagingPhp>
          </div>
        </div>
      )}

    </div>
  );
};

UserListsCarousel.propTypes = {
  page: number,
};

UserListsCarousel.defaultProps = {
  page: 1,
};

UserListsCarousel.displayName = 'UserListsCarousel';

UserListsCarousel.dataModel = extend(dataModel, CreateButtonDesktop, ListTileDesktop);
